import { Image, StyleSheet } from 'react-native'

import { DS } from '../../design-system'

export const LoadingContent = () => {
  return (
    <DS.Frame style={styles.container}>
      <Image source={require('./assets/spinner.gif')} resizeMode="contain" style={styles.loaderImage} />
      <DS.Text variant="Body Medium/Medium" textAlign="center" style={{ marginVertical: 14 }}>
        Submitting
      </DS.Text>
    </DS.Frame>
  )
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    borderRadius: 12,
    paddingVertical: 20,
    backgroundColor: '#F8F4EE'
  },
  loaderImage: {
    alignSelf: 'center',
    width: 42,
    height: 42
  }
})
